import React, { PropTypes } from 'react';
import { v4 } from 'node-uuid';
import isEqual from 'lodash/isEqual';
import { LoadingIndicator } from 'common/components/preloader';
import Meta from 'landing_pages/components/meta';
import ShareBar from 'landing_pages/components/share_bar';
import Author from 'landing_pages/components/author';
import Benefits from 'landing_pages/components/benefits';
import Cta from 'marketing/common/cta';
import Comparison from 'landing_pages/components/comparison';
import EmailSubscriptionForm from 'landing_pages/components/email_subscription_form';
import ExternalPage from 'landing_pages/components/external_page';
import Faq from 'landing_pages/components/faq';
import Featured from 'marketing/common/featured';
import Gallery from 'landing_pages/components/gallery';
import Hero from 'landing_pages/components/hero';
import How from 'landing_pages/components/how';
import How2 from 'landing_pages/components/how_2';
import How3 from 'landing_pages/components/how_3';
import Links from 'landing_pages/components/links';
import Pricing from 'landing_pages/components/pricing';
import PromoBanner from 'landing_pages/components/promo_banner';
import Share from 'landing_pages/components/share';
import SingleTestimonial from 'landing_pages/components/single_testimonial';
import SubscriptionHero from 'landing_pages/components/subscription_hero';
import SubscriptionHero2 from 'landing_pages/components/subscription_hero_2';
import Stats from 'landing_pages/components/stats';
import Support from 'marketing/containers/support';
import Testimonials from 'landing_pages/components/testimonials';
import Story from 'landing_pages/components/story';
import Reviews from 'landing_pages/containers/reviews';
import BlogGallery from 'landing_pages/components/blog_gallery';
import SubCategories from 'landing_pages/containers/sub_categories';
import Differentiators from 'landing_pages/components/differentiators';
import SelectPackageSubcat from 'landing_pages/containers/select_package_subcat';
import Testimonials2 from 'landing_pages/components/testimonials_2';
import RelatedContent from 'landing_pages/components/related_content';
import FeaturedContent from 'landing_pages/components/featured_content';
import Separator from 'landing_pages/components/separator';
import CountdownTimer from 'landing_pages/components/countdown_timer';
import ErrorPage from 'error/components';
import DriftChat from 'common/containers/drift_chat';
import { activateExperiment } from 'common/optimize';
import Breadcrumbs from 'landing_pages/containers/breadcrumbs';

const BLOCK_MAP = {
  author: Author,
  benefits: Benefits,
  blog_gallery: BlogGallery,
  comparison: Comparison,
  countdown_timer: CountdownTimer,
  cta: Cta,
  differentiators: Differentiators,
  email_subscription_form: EmailSubscriptionForm,
  external_page: ExternalPage,
  faq: Faq,
  featured: Featured,
  featured_content: FeaturedContent,
  gallery: Gallery,
  hero: Hero,
  how_it_works: How,
  how_it_works_2: How2,
  how_it_works_3: How3,
  links: Links,
  pricing_package: Pricing,
  promo_banner: PromoBanner,
  related_content: RelatedContent,
  reviews: Reviews,
  select_package_sub_category: SelectPackageSubcat,
  separator: Separator,
  share: Share,
  single_testimonial: SingleTestimonial,
  stats: Stats,
  story: Story,
  sub_categories: SubCategories,
  subscription_hero: SubscriptionHero,
  subscription_hero_2: SubscriptionHero2,
  subscription_hero_ebook: SubscriptionHero,
  support: Support,
  testimonial: Testimonials,
  testimonials: Testimonials,
  testimonials_2: Testimonials2,
};

class LandingPage extends React.Component {
  constructor(props) {
    super(props);

    this.activateExperiments = this.activateExperiments.bind(this);
    this.renderBlock = this.renderBlock.bind(this);
  }

  activateExperiments() {
    this.props.currentExperiments.forEach(exp => activateExperiment(exp.id, exp.variationId));
  }

  componentDidMount() {
    this.props.fetch();
    this.activateExperiments();
  }

  componentDidUpdate(prevProps) {
    const { currentExperiments, params, fetch } = this.props;

    if (prevProps.params.pageSlug !== params.pageSlug) {
      fetch();
    }

    if (!isEqual(prevProps.currentExperiments, currentExperiments)) {
      this.activateExperiments();
    }
  }

  renderBlock(block, i) {
    const { landing_page } = this.props;

    if (!block) {
      return null;
    }

    const Component = BLOCK_MAP[block.block_type];

    if (!Component) {
      return null;
    }

    return (
      <Component key={i}
        {...block.data}
        blockType={block.block_type}
        pageSeoTitle={landing_page.seo_title}
        pageSeoDescription={landing_page.seo_description}
        pageUrlStem={landing_page.url_stem}
      />
    );
  }

  render() {
    const { landing_page, error, hasFaqs } = this.props;

    if (!landing_page && !error) {
      return (<div className="l-content marketing" id="content">
        <LoadingIndicator />
      </div>);
    }

    if (error) {
      const mockRouter = { location: { pathname: '404' } };
      return (<ErrorPage router={mockRouter} />);
    }

    return (
      <div className="l-content marketing" id="content" itemScope={hasFaqs? true : undefined}
          itemType={hasFaqs? "https://schema.org/FAQPage" : undefined}>
        <Meta {...landing_page} />

        <div className="row columns">
          <Breadcrumbs landingPage={landing_page} />
        </div>

        <ShareBar landingPage={landing_page} />

        { (landing_page.page_blocks || []).map(this.renderBlock) }

        <DriftChat />
      </div>
    );
  }
}


LandingPage.propTypes = {
  fetch: PropTypes.func.isRequired,
  landing_page: PropTypes.object,
  error: PropTypes.object,
  hasFaqs: PropTypes.bool.isRequired,
};

export default LandingPage;
